import React, { useState, useEffect } from "react";
import { Form, Avatar, Upload, message } from "antd";
import GainIcon from "../../components/gainicon";
import AddInput from "../../components/objects/AddInput";
import GainButton from "../../components/objects/GainButton";

import { createUser, updateUser } from "../../services/api";
import { baseURL } from "../../config";

export default function Add(props) {
  const Formobject = {
    firstname: "",
    lastname: "",
    ID: "",
    email: "",
    password: "",
    profile: "",
  };

  const [Uploading, setUploading] = useState(false);
  const [Formdata, setFormdata] = useState(Formobject);

  const onChange = (e) => {
    const { name, value } = e.target;
    setFormdata({ ...Formdata, [name]: value });
  };

  const handleSubmit = async () => {
    const res = await createUser(Formdata);
    if (res.status === 200) {
      message.success("Add success");
      props.onFinish();
      setFormdata(Formobject);
    } else {
      message.error("Add faild");
    }
  };

  const handleUpdate = async () => {
    delete Formdata.created_at;
    delete Formdata.updated_at;
    delete Formdata.is_active;

    const res = await updateUser(Formdata.id, Formdata);
    if (res.status === 200) {
      message.success("Edit success");
      props.onFinish();
      setFormdata(Formobject);
    } else {
      message.error("Edit faild");
    }
  };

  useEffect(() => {
    if (props.dataEdit) {
      setFormdata(props.dataEdit);
    } else {
      setFormdata(Formobject);
    }
  }, [props.dataEdit]);

  const upLoadprops = {
    name: "image",
    action: `${baseURL}/api/profile/upload`,
    headers: {
      contentType: "multipart/form-data",
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
        setUploading(true);
      }
      if (info.file.status === "done") {
        message.success(`file uploaded successfully`);
        setUploading(false);
        setFormdata({ ...Formdata, profile: info.file.response.name });
      } else if (info.file.status === "error") {
        message.error(`file upload failed.`);
        setUploading(false);
      }
    },
    showUploadList: false,
  };

  return (
    <div className="w-full add-user">
      <Form onFinish={props.dataEdit ? handleUpdate : handleSubmit}>
        <div className="text-center relative max-w-max mx-auto">
          {Uploading && (
            <div className="uploading">
              <span>uploading...</span>
            </div>
          )}
          <Avatar
            size={150}
            src={
              Formdata.profile
                ? `${baseURL}/api/images/${Formdata.profile}`
                : "/images/avatar/add.png"
            }
          />
          <div className="absolute bottom-0 right-0 z-10">
            <Upload {...upLoadprops}>
              <GainIcon name="edit-upload" />
            </Upload>
          </div>
        </div>
        <div className="pt-8">
          <Form.Item
            name="firstname"
            rules={[{ required: true, message: "Please input Firstname!" }]}
          >
            <AddInput
              type="text"
              label="Name"
              placeholder="First Name"
              name="firstname"
              value={Formdata.firstname}
              onChange={onChange}
            />
          </Form.Item>
          <Form.Item
            name="lastname"
            rules={[{ required: true, message: "Please input Lastname!" }]}
          >
            <AddInput
              type="text"
              label={<div className="opacity-0"></div>}
              placeholder="Last Name"
              name="lastname"
              value={Formdata.lastname}
              onChange={onChange}
            />
          </Form.Item>
          <Form.Item
            name="ID"
            rules={[{ required: true, message: "Please input ID!" }]}
          >
            <AddInput
              type="text"
              label="ID"
              placeholder="ID"
              name="ID"
              value={Formdata.ID}
              onChange={onChange}
            />
          </Form.Item>
          <Form.Item
            name="Email"
            rules={[
              {
                type: "email",
                required: true,
                message: "${label} is not a valid email!",
              },
            ]}
          >
            <AddInput
              type="text"
              label="Email"
              placeholder="Email"
              name="email"
              value={Formdata.email}
              onChange={onChange}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: "Please input password!" }]}
          >
            <AddInput
              type="text"
              label="Password"
              placeholder="Password"
              name="password"
              value={Formdata.password}
              onChange={onChange}
            />
          </Form.Item>
        </div>
        <GainButton className="mt-6" label="Save" htmlType="submit" center />
      </Form>
    </div>
  );
}
